export default "__VITE_ASSET__DrtJcLos__"